export const FIELDS = [
  {
    name: 'rut',
    inputAdornment: '',
    label: 'RUT',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
  {
    name: 'clientName',
    inputAdornment: '',
    label: 'Nombre completo',
    textArea: '',
    disabled: false,
    required: true,
  },
  {
    name: 'phone',
    inputAdornment: '',
    label: 'Teléfono',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresar 9 dígitos',
  },
  {
    name: 'email',
    inputAdornment: '',
    label: 'Correo',
    disabled: false,
    required: true,
  },
  {
    name: 'comment',
    multiline: true,
    rows: 4,
    inputAdornment: '',
    label: 'Escribir comentario',
    textArea: 'Escribir comentario',
    disabled: false,
    required: false,
    helper: '',
  },
];
